import { Component, h, Prop } from '@stencil/core'
import './udp-calendar-week.css'

@Component({
  tag: 'udp-calendar-week',
  styleUrl: 'udp-calendar-week.css',
  shadow: true,
})
export class UdpCalendarWeek {
  @Prop() props: any = {}

  componentWillLoad() { 
    
  }

  render() {
    return (
      <udp-calendar-base initialView='dayGridWeek' {...this.props}></udp-calendar-base>
    )
  }
}
